<template>
  <v-container id="orcamentos" fill-height fluid grid-list-xl tag="section">
    <v-layout justify-center wrap>
      <v-flex xs12 md12>
        <div class="text-center ma-2">
          <v-snackbar
            v-model="snackbar"
            :color="snackbarColor"
            :timeout="timeout"
            top
          >
            {{ textSnackbar }}
            <v-btn
              class="mx-2"
              fab
              small
              color="white"
              text
              @click="snackbar = false"
              dark
            >
              <v-icon dark>mdi-close-thick</v-icon>
            </v-btn>
          </v-snackbar>
        </div>
        <v-card>
          <div>
            <v-dialog v-model="loading" hide-overlay persistent width="300">
              <v-card color="primary" dark>
                <v-card-text>
                  Buscando informações, aguarde ...
                  <v-progress-linear
                    indeterminate
                    color="white"
                    class="mb-0"
                  ></v-progress-linear>
                </v-card-text>
              </v-card>
            </v-dialog>
          </div>

          <filtro-data />
          <estatisticas-orcamentos />
          <!-- <v-container fluid> -->
          <v-card v-if="totalizadoresOrc.length" class="mx-auto text-center">
            <v-container fluid>
              <v-row dense>
                <v-col v-for="total in totalizadoresOrc" :key="total.title">
                  <v-card class="d-flex flex-wrap justify-center">
                    <v-card-title
                      class="justify-center"
                      v-text="total.title"
                    ></v-card-title>
                    <v-card-text>
                      <v-chip class="ma-2" color="green" text-color="white">{{
                        total.value | dinheiro
                      }}</v-chip>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
          <!-- </v-container> -->
          <v-card-title>
            Orçamentos
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Filtrar"
              single-line
              hide-details
            ></v-text-field>
            <v-dialog
              v-model="dialogOrcamento"
              max-width="950px"
              @keydown.esc="aoFecharDiaogOrcamento"
            >
              <Orcamento />
            </v-dialog>
          </v-card-title>
          <v-data-table
            dense
            :headers="headers"
            :items="orcamentos"
            :search="search"
            :items-per-page="5000"
            sort-by="['cdfil','nrorc','serieo']"
            sort-desc
            multi-sort
            item-key="id"
            class="elevation-3"
          >
            <template v-slot:[`item.action`]="{ item }">
              <v-icon
                small
                color="primary"
                class="mr-0"
                @click="visualizarOrcamento(item)"
                >mdi-file-eye-outline</v-icon
              >
            </template>
            <template v-slot:[`item.orcamento`]="{ item }">{{
              `${item.nrorc}${item.serieo}`
            }}</template>
            <template v-slot:[`item.aprovado`]="{ item }">
              <v-chip
                small
                text-color="white"
                label
                :color="getColorAprovado(item.aprovado)"
                >{{ item.aprovado }}</v-chip
              >
            </template>
            <template v-slot:[`item.prcusto`]="{ item }">{{
              item.prcusto | dinheiro
            }}</template>
            <template v-slot:[`item.prvenda`]="{ item }">{{
              item.prvenda | dinheiro
            }}</template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import FiltroData from "../components/filtros/FiltroData";
import EstatisticasOrcamentos from "../views/EstatisticasOrcamentos";
import { mapGetters } from "vuex";
import { mapActions } from "vuex";
import Orcamento from "../views/Orcamento";
export default {
  components: {
    FiltroData,
    Orcamento,
    EstatisticasOrcamentos,
  },
  data: () => ({
    headers: [
      { text: "", value: "action", sortable: false, width: 1 },
      { text: "Lj", align: "start", sortable: true, value: "cdfil", width: 1 },
      { text: "Orç.", align: "start", sortable: true, value: "nrorc" },
      { text: "Sr", align: "start", sortable: true, value: "serieo" },
      { text: "Aprov.", align: "start", sortable: true, value: "aprovado" },
      { text: "Emissão", align: "start", sortable: true, value: "dtcad" },
      { text: "Cliente", align: "start", sortable: true, value: "nomecli" },
      { text: "Custo", align: "end", sortable: true, value: "prcusto" },
      { text: "Fator", align: "end", sortable: true, value: "fatorV" },
      { text: "Valor", align: "end", sortable: true, value: "prvenda" },
    ],

    pagination: {
      descending: true,
      page: 1,
      totalItems: 0,
    },
    orcamentos: [],
    totalizadoresOrc: [],
    totalizadores: [],
    dialogOrcamento: false,
    search: "",
    loading: false,
    errored: false,
    snackbar: false,
    textSnackbar: "",
    snackbarColor: "",
    timeout: 10000,
    estatisticasOrcPorCanal: [],
    estatisticasOrcPorLoja: [],
    estatisticasOrcPorTipoCliente: [],
    estatisticasOrcPorStatus: [],
  }),

  created() {
    if (!this.orcamentos.length) {
      this.$store.dispatch("adicionarEstatisticaOrcamentosPorLoja", null),
        this.$store.dispatch("adicionarEstatisticaOrcamentosPorCanal", null),
        this.$store.dispatch(
          "adicionarEstatisticaOrcamentosPorTipoCliente",
          null
        ),
        this.$store.dispatch("adicionarEstatisticaOrcamentosPorStatus", null);
    }
  },
  computed: {
    ...mapGetters({
      dataInicioStore: "dataInicial",
      dataFimStore: "dataFinal",
      clickBtnFiltroData: "clickFiltroData",
    }),
  },
  watch: {
    dataInicioStore: function () {
      this.listarOrcamentos();
      this.loading = true;
    },
    dataFimStore: function () {
      this.listarOrcamentos();
      this.loading = true;
    },

    clickBtnFiltroData: function () {
      this.listarOrcamentos();
      this.loading = true;
    },
  },
  methods: {
    ...mapActions([
      "adicionarFiltroOrcamento",
      "adicionarEstatisticaOrcamentosPorLoja",
      "adicionarEstatisticaOrcamentosPorCanal",
      "adicionarEstatisticaOrcamentosPorTipoCliente",
      "adicionarEstatisticaOrcamentosPorStatus",
    ]),
    aoFecharDiaogOrcamento() {
      this.dialogOrcamento = false;
    },

    listarOrcamentos() {
      this.$http
        .get("orcamentos", {
          params: {
            dataInicial: this.dataInicioStore,
            dataFinal: this.dataFimStore,
          },
        })
        .then((res) => {
          if (res.data.listaOrcamentos.length) {
            this.orcamentos = res.data.listaOrcamentos;
            this.totalizadoresOrc = res.data.totalizadoresOrc;
            this.estatisticasOrcPorCanal = [];
            this.estatisticasOrcPorCanal.push(
              res.data.chartOrcCanalQtde,
              res.data.chartOrcCanalValor,
              res.data.totalPorCanalOrc
            );
            this.estatisticasOrcPorLoja = [];
            this.estatisticasOrcPorLoja.push(
              res.data.chartOrcLojaQtde,
              res.data.chartOrcLojaValor,
              res.data.totalPorLojaOrc
            );
            this.estatisticasOrcPorTipoCliente = [];
            this.estatisticasOrcPorTipoCliente.push(
              res.data.chartOrcTipoClienteQtde,
              res.data.chartOrcTipoClienteValor,
              res.data.totalPorTipoCliente
            );
            this.estatisticasOrcPorStatus = [];
            this.estatisticasOrcPorStatus.push(
              res.data.chartOrcStatusQtde,
              res.data.chartOrcStatusValor,
              res.data.totalPorStatusOrc
            );
            this.adicionarEstatisticasOrcamentos();
          } else {
            this.textSnackbar = "Não há dados para o período.";
            this.snackbar = true;
            this.snackbarColor = "info";
          }
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.status === 400) {
              this.textSnackbar = error.response.data.message;
              this.snackbar = true;
              this.snackbarColor = "error";
            }
          }
        })
        .finally(() => (this.loading = false));
    },
    visualizarOrcamento(item) {
      const orcamentoSelecionado = [
        `${item.cdfil}`,
        `${item.nrorc}`,
        `${item.serieo}`,
      ];
      this.$store.dispatch("adicionarFiltroOrcamento", orcamentoSelecionado);
      this.dialogOrcamento = true;
    },
    adicionarEstatisticasOrcamentos() {
      this.$store.dispatch(
        "adicionarEstatisticaOrcamentosPorCanal",
        this.estatisticasOrcPorCanal
      );
      this.$store.dispatch(
        "adicionarEstatisticaOrcamentosPorLoja",
        this.estatisticasOrcPorLoja
      );
      this.$store.dispatch(
        "adicionarEstatisticaOrcamentosPorTipoCliente",
        this.estatisticasOrcPorTipoCliente
      );
      this.$store.dispatch(
        "adicionarEstatisticaOrcamentosPorStatus",
        this.estatisticasOrcPorStatus
      );
    },
    getColorAprovado(item) {
      if (item == "Sim") {
        return "green";
      } else {
        return "orange";
      }
    },
  },
};
</script>

<style>
</style>
